// extracted by css-extract-rspack-plugin
export default {"cls1":"ButtonsPage-cls1_gRg","cls2":"ButtonsPage-cls2_sjy ButtonsPage-cls1_gRg"};